
import { version } from '../package.json';

console.log(`Version of Solidify ${version}`);
export default {
  name: 'Home',
  methods: {
    goToHome(): void {
      // console.log(this);
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      // window.haha = this;
      this.$root.singleSpa.navigateToUrl('/solidify');
    },
  },
};
